import React from 'react';
import classNames from 'classnames';
import cls from './CardTitle.module.css';
import { Roles } from '../../../../AddProject/types/types';

interface CardTitleProps {
    classes?: string;
    title: string;
    role: Roles;
}

export const CardTitle = ({ classes, title, role }: CardTitleProps) => {
    return (
        <div className={cls.Container}>
            <span className={classNames(cls.CardTitle, [classes])}>{title}</span>
        </div>
    );
};
